class ProjectsBlockComponent extends React.Component{	
	render(){
		return (
					<section id="projects__block" className="projects__block">
						<h1 className="projects__block__heading">Some Projects and Codepen Demos</h1>
						<div className="projects__block__grid">
							<h2 className="projects__block__grid__pens__title">-Projects</h2>
							
							<article className="projects__block__project__container col-xs-6">
								<div className="projects__block__project__info__container col-xs-6 col-md-3">
									<div className="projects__block__project__info__container__wrapper">
										<h3 className="projects__block__project__title__text">
										Mr.Bean Site - Jollywise
										</h3>
										<p className="projects__block__project__info__text">Yes, we all know him and we all love him! It's Mr.Bean!! This was one of the first projects at Jollywise, and I was responsible for the front-end markup and styling of the site. This site has one of the most interesting and "funky" layouts I've ever worked on. Jagged lines, weird containers, overflowing characters, carousels and custom themed youtube playlists, all go together to produce a funny website that certainly matches our favourite character. Click <a href="http://www.mrbean.com/" target="_blank">here</a> to visit the Mr.Bean site.</p>
									</div>
								</div>
								
								<div className="projects__block__project__pen__container col-xs-6 col-md-3">
									<img src="assets/img/bean.png" />
									<div className="projects__block__project__pen__circle__container">
										<div className="projects__block__project__pen__circle__mask">
										</div>
									</div>
								</div>
							</article>
							
							<article className="projects__block__project__container col-xs-6">
								<div className="projects__block__project__info__container col-xs-6 col-md-3">
									<div className="projects__block__project__info__container__wrapper">
										<h3 className="projects__block__project__title__text">
										Ivandoe Site - Jollywise
										</h3>
										<p className="projects__block__project__info__text">This was another project at Jollywise, created for Cartoon Network, and I was responsible for the front-end development. Designed by our amazing team and powered by our own CMS at the backend, this site is certainly one of the most fun to work on and maintain. With this project I was lucky to explore Vue.js in depth, another frontend Javascript library using the same component based architecture as React and the like. From a cartoonish, animating, responsive layout to embedded videos, quizzes and ads using external third party libraries and API's. All working in harmony and as decoupled as possible. Click <a href="http://ami.responsivedesign.is/?url=http://ivandoehub.cartoonnetwork.co.uk" target="_blank">here</a> to load the Ivandoe site in responsive previews on ami.responsivedesign.is</p>
									</div>
								</div>
								
								<div className="projects__block__project__pen__container col-xs-6 col-md-3">
									<img src="assets/img/ivandoeResponsive.png" />
									<div className="projects__block__project__pen__circle__container">
										<div className="projects__block__project__pen__circle__mask">
										</div>
									</div>
								</div>
							</article>
							
							<article className="projects__block__project__container col-xs-6">
								<div className="projects__block__project__info__container col-xs-6 col-md-3">
									<div className="projects__block__project__info__container__wrapper">
										<h3 className="projects__block__project__title__text">
											JargonBuster - iCrossing
										</h3>
										<p className="projects__block__project__info__text">The JargonBuster is a tool that serves as a glossary for SEO related abbreviations. This was my first project at iCrossing and most of the DOM manupulation is handled in vanilla JavaScript. After facing most of the pitfalls a starter can face using JS, I was able to understand the purpose and benefits of using libraries and I started exploring Javascript Design Patterns. Click <a href="http://ami.responsivedesign.is/?url=https://jbwebapp-e5f50.firebaseapp.com/" target="_blank">here</a> to load the JargonBuster in responsive previews on ami.responsivedesign.is</p>
									</div>
								</div>
								
								<div className="projects__block__project__pen__container col-xs-6 col-md-3">
									<img src="assets/img/jbResponsive.png" />
									<div className="projects__block__project__pen__circle__container">
										<div className="projects__block__project__pen__circle__mask">
										</div>
									</div>
								</div>
							</article>
							
							
							<article className="projects__block__project__container col-xs-6">
								<div className="projects__block__project__info__container col-xs-6 col-md-3">
									<div className="projects__block__project__info__container__wrapper">
										<h3 className="projects__block__project__title__text">
										AudioActive styling - iCrossing
										</h3>
										<p className="projects__block__project__info__text">For this project my responsibility was the styling of the website using SASS. After using SASS on this project I was able to understand how more managable, expressive and even scoped css can become using the syntactic sugar of SASS. Click <a href="http://ami.responsivedesign.is/?url=http://audioactive.org.uk/" target="_blank">here</a> to load the AudioActive site in responsive previews on ami.responsivedesign.is</p>
									</div>
								</div>
								
								<div className="projects__block__project__pen__container col-xs-6 col-md-3">
									<img src="assets/img/audioActiveResponsive.png" />
									<div className="projects__block__project__pen__circle__container">
										<div className="projects__block__project__pen__circle__mask">
										</div>
									</div>
								</div>
							</article>
							
							
							<h2 className="projects__block__grid__pens__title">-Pens</h2>
							<article className="projects__block__project__container col-xs-6">
								<div className="projects__block__project__info__container col-xs-6 col-md-3">
									<div className="projects__block__project__info__container__wrapper">
										<h3 className="projects__block__project__title__text">
											Animating SVG using GSAP
										</h3>
										<p className="projects__block__project__info__text">In this demo I am exploring SVG animations using GSAP
										and the MorphSVGPlugin. Three heart paths are drawn representing the key-frames of the animation and using
										the MorphSVGPlugin, the initial heart path is transformed as defined by the key-frames. This demo is also using 
										the Web Audio API using a pulse playback sound that repeats as the animation cycles.</p>
									</div>
								</div>
								
								<div className="projects__block__project__pen__container col-xs-6 col-md-3">
									<iframe height='300' scrolling='no' title='HeartBeat' src='//codepen.io/RedGlove/embed/preview/woaBwd/?height=265&theme-id=light&default-tab=result&embed-version=2' frameBorder='no' allowtransparency='true' allowFullScreen={true} >See the Pen <a href='http://codepen.io/RedGlove/pen/woaBwd/'>HeartBeat</a> by Emmanuel Lainas (<a href='http://codepen.io/RedGlove'>@RedGlove</a>) on <a href='http://codepen.io'>CodePen</a>.
									</iframe>
									<div className="projects__block__project__pen__circle__container">
										<div className="projects__block__project__pen__circle__mask">
										</div>
									</div>
								</div>
							</article>
							
							
							<article className="projects__block__project__container col-xs-6">
								<div className="projects__block__project__info__container col-xs-6 col-md-3">
									<div className="projects__block__project__info__container__wrapper">
										<h3 className="projects__block__project__title__text">
										Animated menus palette using CSS transitions
										</h3>
										<p className="projects__block__project__info__text">In this demo I created an animated menus palette using css transitions, for the default html structure generated by WordPress. These animations are using the ::before and ::after pseudo-elements to avoid the need of defining a custom menu walker for WordPress.</p>
									</div>
								</div>
								
								<div className="projects__block__project__pen__container col-xs-6 col-md-3">
									<iframe height='300' scrolling='no' title='Animated menus palette for WordPress default menu structure' src='//codepen.io/RedGlove/embed/preview/gWLNbg/?height=265&theme-id=light&default-tab=result&embed-version=2' frameBorder='no' allowtransparency='true' allowFullScreen={true} >See the Pen <a href='http://codepen.io/RedGlove/pen/gWLNbg/'>Animated menus palette for WordPress default menu structure</a> by Emmanuel Lainas (<a href='http://codepen.io/RedGlove'>@RedGlove</a>) on <a href='http://codepen.io'>CodePen</a>.
									</iframe>
									<div className="projects__block__project__pen__circle__container">
										<div className="projects__block__project__pen__circle__mask">
										</div>
									</div>
								</div>
							</article>
							<div className="col-xs-6 projects__block__more__pens">
								<a href="http://codepen.io/RedGlove/" target="_blank">more pens</a>
							</div>			
						</div>
					</section>
		);
	}
}
export { ProjectsBlockComponent };


// WEBPACK FOOTER //
// in/js/custom-components/projects/projects-block-component.js